class AudioAnalysisManager {
    constructor () {
        this.context = null
        this.analysers = new Map() // trackId -> { analyser, dataArray }
    }

    // Lazy-init the context (must be after a user gesture)
    init () {
        if ( !this.context ) {
            this.context = new ( window.AudioContext || window.webkitAudioContext )()
        }
        if ( this.context.state === 'suspended' ) {
            this.context.resume()
        }
    }

    getAnalyser ( audioTrack ) {
        this.init()
        const trackId = audioTrack.getTrackId()
        const mediaTrack = audioTrack.getMediaStreamTrack()
        const cached = this.analysers.get( trackId )

        // Check if we need to (re)create the connection
        // If no cache OR the internal track has changed/restarted
        if ( !cached || cached.mediaTrack !== mediaTrack ) {

            // Cleanup old source if it exists to prevent memory leaks
            if ( cached && cached.source ) {
                cached.source.disconnect()
            }

            const stream = new MediaStream( [mediaTrack] )
            const source = this.context.createMediaStreamSource( stream )
            const analyser = this.context.createAnalyser()
            analyser.fftSize = 64
            source.connect( analyser )

            const analysisObj = {
                analyser,
                source,
                mediaTrack, // Store the actual track to compare later
                dataArray: new Uint8Array( analyser.frequencyBinCount )
            }

            this.analysers.set( trackId, analysisObj )
            return analysisObj
        }

        return cached
    }

    // Cleanup when a user leaves
    removeTrack ( trackId ) {
        this.analysers.delete( trackId )
    }
}

export const audioAnalysisManager = new AudioAnalysisManager()